'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: '服务暂时不可用，请稍后重试.',
    NEED_ACTIVE: '您的账号{{account}}首次使用本网站业务，请{{activeLink}}完成激活后，回到本页继续操作。',
    GOTO_ACTIVE: '立即激活',
    NOT_ACTIVED: '账号尚未激活成功，请{{activeLink}}完成激活。',
    COMPLETE_ACTIVE: '确认激活成功',
    FORBID_ACTIVE: '此账号不支持登录AliExpress',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: '使用其他账号登录',
    ACTIVE_PAGE: '访问帐号激活页面'
};